
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CustomerOutstandingPDCBarChart from '@/components/reports-v3/components/codedWidgets/custom/wls/CustomerOutstandingPDCBarChart.vue';
import CustomerDueWithPDCTable from '@/components/reports-v3/components/codedWidgets/custom/wls/CustomerDueWithPDCTable.vue';
import CustomerDueWithPDCTableAll from '@/components/reports-v3/components/codedWidgets/custom/wls/CustomerDueWithPDCTableAll.vue';
import CustomerDueWithPDCTablePromo from '@/components/reports-v3/components/codedWidgets/custom/wls/CustomerDueWithPDCTablePromo.vue';
import userx from '@/store/modules/userx';
import router from '@/router';
import LastSync from '@/components/LastSync.vue';
import StickyFilterContainer from '@/components/reports-v3/components/pages/StickyFilterContainer.vue';
import DateFilter from '@/components/reports-v3/components/filters/DateFilter.vue';
import moment from 'moment';
import CustomerListFilter from '@/components/reports-v3/components/filters/CustomerListFilter.vue';
import AgentsListFilter from '@/components/reports-v3/components/filters/AgentsListFilter.vue';

@Component({
	components: {
		LastSync,
		CustomerOutstandingPDCBarChart,
		StickyFilterContainer,
		DateFilter,
		CustomerListFilter,
		CustomerDueWithPDCTableAll,
		CustomerDueWithPDCTable,
        CustomerDueWithPDCTablePromo,
		AgentsListFilter,
	},
})
export default class WlsCustomerAging extends Vue {
	public selectedDay: number = moment().endOf('day').valueOf();
	public selectedAgents: string[] = [];
	public selectedCustomers: string[] = [];

	public mounted() {
		this.track();
	}

	public track() {
		this.$ga.set('userId', userx.user!.uid + '_' + userx.user!.email);
		this.$ga.page(router);
	}

	public get selectedAsOfDate() {
		return moment(this.selectedDay).endOf('day').valueOf();
	}

	// public get selectedAgents() {
	// 	return gdbx.allAgents;
	// }

	public onHovering(value: boolean, filterId: string) {
		this.$emit('hovering', value, filterId);
	}
	public onEditing(value: boolean, filterId: string) {
		this.$emit('editing', value, filterId);
	}
}
